<template>
    <section class="container" ref="homeCont">
      <div class="route">
        {{$locales.ajustes.ajustes}} > {{$locales.ajustes.alertas.alertas}} > {{$locales.ajustes.alertas.facturas}}
      </div>
      <div class="sidebar">
        <span class="principal">
          <span class="icon">J  </span>{{$locales.ajustes.ajustes}}
        </span>
        <ul>
          <li @click="toggle">
            <span class="sidebar-item"><span class="arrow">&#9660;</span>{{$locales.ajustes.alertas.alertas}}</span>
                <span @click="refresh"><router-link to="/onesaitConfirmingProviders/ajustes/alertas/facturas"  class="link-active" v-if="active">
                  {{$locales.ajustes.alertas.facturas}}
                </router-link></span>
          </li>
          <li  @click="toggle2">
                <span class="sidebar-item">
                  <span class="arrow">&#9660; </span>{{$locales.ajustes.seguridadclaves.seguridadclaves}}
                </span>
                <router-link to="/onesaitConfirmingProviders/ajustes/modificar-contrasena" class="link" v-if="active2">
                {{$locales.ajustes.seguridadclaves.modificarpassword}}
                </router-link>
                <router-link to="/onesaitConfirmingProviders/ajustes/modificar-claveFirma"  class="link" v-if="active2">
                {{$locales.ajustes.seguridadclaves.modificarclavefirma}}
                </router-link>
          </li>
          <li  @click="toggle3">
                <span class="sidebar-item">
                  <span class="arrow">&#9660; </span>{{$locales.ajustes.datospersonales.datospersonales}}
                </span>
                <router-link to="/onesaitConfirmingProviders/ajustes/datos-personales/modificar-datos" class="link" v-if="active3">
                {{$locales.ajustes.datospersonales.modificardatos}}
                </router-link>
          </li>
        </ul>
      </div>
      <div class="window">
        <div class="mensajeConfirmacion" v-if="confirmacion=='OK'">
          <p>check_circle</p>
          <h3>Operación realizada con éxito</h3>
       </div>
       <div class="mensajeError" v-else-if="confirmacion=='KO'">
          <p>cancel</p>
          <h3>{{mensajeError}}</h3>
       </div>
        <h1>{{$locales.ajustes.alertas.facturas}}</h1>
        <div class="form-group">
          <form class="window-form" @submit.prevent="aceptar">
            <div class="row">
              <div class="column">
                <label for="alertActiveCombo">Activa</label>
                <md-field class="anchoCombo100">
                  <md-select v-model="model.alertActive" class="combo" name="alertActiveCombo" id="alertActiveCombo">
                    <md-option value="A">Sí</md-option>
                    <md-option value="I">No</md-option>
                  </md-select>
                  <div class="error" v-if="submitted && !$v.model.alertActive.required">Este campo es obligatorio</div>
                </md-field>
              </div>
              <div id="columnaHoras">
                <label for="horaDesde">Hora</label>
                <div class="compositeComponent">
                  <!-- Input -->
                  <input v-model="model.timeFrom" v-on:blur=onTimeFormat(model.timeFrom,1) :class = "(submitted && $v.model.timeFrom.$invalid)?'inputInvalid':'inputComponent'" type="text" maxlength="5" id="timeFrom" step="any" name="timeFrom" autocomplete="off" placeholder="Desde                HH:MM" />
                  <!-- Input -->
                  <input v-model="model.timeTo" v-on:blur=onTimeFormat(model.timeTo,2)  :class = "(submitted && $v.model.timeTo.$invalid)?'inputInvalid lastElement':'inputComponent lastElement'" type="text" maxlength="5" id="timeTo" step="any" name="timeTo" autocomplete="off" placeholder="Hasta                HH:MM"/>
                  <!-- Posibles errores de validacion -->
                  <div class="error" v-if="submitted && !$v.model.timeFrom.required">El campo 'hora desde' es obligatorio</div>
                  <div class="error" v-if="submitted && !$v.model.timeTo.required">El campo 'hora hasta' es obligatorio</div>
                  <div class="error" v-if="submitted && !$v.model.timeFrom.minLength">El campo 'hora desde' debe de tener como mínimo 4 caracteres</div>
                  <div class="error" v-if="submitted && !$v.model.timeTo.minLength">El campo 'hora hasta' debe de tener como mínimo 4 caracteres</div>
                  <div class="error" v-if="submitted && $v.model.timeTo.$invalid">La hora final no puede ser inferior a la hora inicial</div>
                </div>
              </div>
            </div>

            <div class="rowStart">
              <div class="margenCheckSwitch checkAlertas">
                <md-checkbox v-model="model.sms">{{$locales.ajustes.alertas.sms}}</md-checkbox>
              </div>
              <div class="margenCheckSwitch checkAlertas">
                <md-checkbox v-model="model.email">{{$locales.ajustes.alertas.email}}</md-checkbox>
              </div>
            </div>
            <!-- Boton aceptar -->
            <input class="btnPrimary" type="submit" value="Aceptar" :disabled="isDisabled" v-if=beforeSubmit>
          </form>
        </div>
        <div v-if=datosFirma>
             <SignatureComponent :params="params" :datosFirma="datosFirma" :llamada="llamada" @aceptar="callBackAceptar" @cancelar="callBackCancelar"></SignatureComponent>
      </div> 
      </div>
    </section>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import InvoicesAlerts from '../models/InvoicesAlerts';
import SignatureComponent from './SignatureComponent';
export default {
    name : 'InvoicesAlertsComponent',
    data(){
      return{
        active: true,
        active2: false,
        active3: false,
        submitted: false,
        beforeSubmit: true,
        mensajeError: null,
        datosFirma: null,
        confirmacion: null,
        llamada: null,
        params: null,
        canales:[],
        resultado:null,
        model : new InvoicesAlerts()
      }
    },

     components: {
      SignatureComponent
    },

   created: function(){ //llamada a /api-notifications/notifications/userConditions para obtener condiciones 
      const ventana=this;
      const baseURI = '/api-notifications/notifications/userConditions';
      let loader = this.$loading.show();

      this.$http.get(baseURI)
      .then((result) => {
        this.resultado=result;
        if(result.data.data.alerts == true) {
          ventana.obtenerDatos();
        } else {
          this.$router.push({ name:'condicionesAlertas'}).catch(()=>{});
        }
      })
      .catch(error => {
        if(error.response){
          var codError = null; 
          var descError = null;
          if(error.response.status != 200) {
            if(error.response.data.result.errors[0].errorCode == "096H") {
              this.datosFirma = error.response.data.result.errors[0].info;
              this.beforeSubmit = false;
            } else {
              codError = error.response.data.result.errors[0].errorCode;
              descError = error.response.data.result.errors[0].errorDescription;
              this.mensajeError = codError + " - " + descError;
              this.confirmacion = "KO";
              loader.hide();
              window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
              });
            }
          }
        }else{ //si no, por defecto
          ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
          ventana.confirmacion='KO';
        }
      })
      .then(function () {
        loader.hide();
      });
    },
    

    mounted(){
    },
    computed : {
      isDisabled: function() {
        return  !this.model.alertActive || !this.model.timeFrom || !this.model.timeTo;
      }
    },
    validations : {
      model : {
        alertActive: {
          required
        },
        timeFrom: {
          required,
          minLength: minLength(4)
        },
        timeTo: {
          required,
          minLength: minLength(4),
          compareTimes: function() { //validacion personalizada
            if(this.model.timeFrom!='' && this.model.timeFrom!=null  && this.model.timeTo!='' && this.model.timeTo!=null){
              return (parseInt(this.model.timeFrom)<=parseInt(this.model.timeTo));
            }else{
              return true;
            }
          }
        },
      }
    },
    methods: {
      refresh(){ //esto tiene la funcion de refrescar el componente cuando volvemos a clickar sobre el en las NavigationBars
        this.$parent.keyRefresh+=1; //al cambiar la key de esta section que lo abarca todo, vue dispara un update
      },
      callBackAceptar(confirmacion, mensaje){
      this.beforeSubmit = false;
      this.confirmacion = confirmacion;
      this.mensajeError = mensaje;
      this.datosFirma = null;
      },
     callBackCancelar(){
         this.beforeSubmit = true;
         this.datosFirma = null;
      },
      toggle () {
        this.active = true;
        this.active2 = false;
        this.active3 = false;
      },
      toggle2 () {
        this.active = false;
        this.active2 = true;
        this.active3 = false;
      },
      toggle3 () {
        this.active = false;
        this.active2 = false;
        this.active3 = true;
      },     

      onTimeFormat(value, number) {
        const parsed = Number.parseInt(value, 10);
        if(value.toString().length == 4 && !Number.isNaN(parsed) && value <= 2359 && value >= 0) {
          if(parsed.toString().length == 4 || 
          (parsed.toString().length == 3 && value.substring(0,1)=='0') || 
          (parsed.toString().length == 2 && value.substring(0,2)=='00') ||
          (parsed.toString().length == 1 && value.substring(0,3)=='000') ||
          (parsed.toString().length == 1 && value=='0000')) {
            if(number==1) {
              this.model.timeFrom = value.substring(0,2) + ':' + value.substring(2,4);
            } else {
              this.model.timeTo = value.substring(0,2) + ':' + value.substring(2,4);
            }
          }
        } 
      },
       onTimeDeformat(model) {
         model.timeFrom = model.timeFrom.split(':').join("");
         model.timeTo = model.timeTo.split(':').join("");
         return model;
      },

      obtenerDatos() {//llamada a /api-notifications/notifications/subscription para obtener los datos
   
        const ventana=this;
        const baseURI = '/api-notifications/notifications/subscription';
        let loader = this.$loading.show();

        const options = {
          params: {
              'alertType': '93'
          }
        };
        
        //this.model.email=true; al ser la unica opcion, la activamos por defecto, si esto cambia en un futuro utilizad la linea inferior

        this.$http.get(baseURI,options)
        .then((result) => {
          this.resultado=result;
          if(result.data.data[0]!=null)
          {
            this.model.alertActive=result.data.data[0].state.id;
            this.model.timeFrom=result.data.data[0].timeFrom;
            this.model.timeTo=result.data.data[0].timeTo;
            this.model.email=(result.data.data[0].notificationChannels[0]=='mail' || result.data.data[0].notificationChannels[1]=='mail' || result.data.data[0].notificationChannels[2]=='mail') ? true : false;
            this.model.sms=(result.data.data[0].notificationChannels[0]=='sms' || result.data.data[0].notificationChannels[1]=='sms' || result.data.data[0].notificationChannels[2]=='sms') ? true : false;
          }
        })
        .catch(error => {
          if(error.response){
            var codError = null; 
            var descError = null;
            if(error.response.status != 200) {
              if(error.response.data.result.errors[0].errorCode == "096H") {
                this.datosFirma = error.response.data.result.errors[0].info;
                this.beforeSubmit = false;
              } else {
                codError = error.response.data.result.errors[0].errorCode;
                descError = error.response.data.result.errors[0].errorDescription;
                this.mensajeError = codError + " - " + descError;
                this.confirmacion = "KO";
                loader.hide();
                window.scroll({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
                });
              }
            }
          }else{ //si no, por defecto
            ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
            ventana.confirmacion='KO';
          }
        })
        .then(function () {
          loader.hide();
        });
      },
      
      aceptar() {////SE ENVIAN LOS DATOS AL SERVICIO
       this.submitted = true;
       this.$v.$touch();
       if(this.$v.$invalid) {
        return false;
       }else {
        const ventana=this;
        const baseURI = '/api-notifications/notifications/subscription';
        this.llamada = {
          urlEndpoint : baseURI,
          metodo : 'POST'
        };

        if(this.model.sms){
          this.canales.push('sms');
        }

        if(this.model.email){
          this.canales.push('mail');
        }
        /*var body={
          'state': this.model.alertActive,
          'notificationChannels': this.canales,
          'timeFrom': this.model.timeFrom,
          'timeTo': this.model.timeTo,
          'eventId': this.resultado.data.data[0].eventId,
          'eventGroup': this.resultado.data.data[0].eventGroup,
          'amount': this.resultado.data.data[0].amount,
          'period': this.resultado.data.data[0].period,
          'eventType': this.resultado.data.data[0].eventType,
        
          
        };*/
        let eventId;
        let eventGroup;
        let amount;
        let period;
        let eventType;
        /*if(this.resultado.data.data[0]!=null){
          eventId= this.resultado.data.data[0].eventId;
          eventGroup= this.resultado.data.data[0].eventGroup;
          amount= this.resultado.data.data[0].amount;
          period= this.resultado.data.data[0].period;
          eventType= this.resultado.data.data[0].eventType;
        }else{*/
        eventGroup="person";
        eventId="093";
        amount={
          amount:0,
          currency:{
            code: "EUR",
            id: "978"
          }
        };
        //}
        
        let loader = this.$loading.show();
          this.params = [{
            'state': this.model.alertActive,
            'notificationChannels': this.canales,
            'timeFrom': this.model.timeFrom,
            'timeTo': this.model.timeTo,
            'eventId': eventId,
            'eventGroup': eventGroup,
            'amount': amount,
            'period': period,
            'eventType': eventType,
          }];
        
          /*this.$http.put(baseURI, this.params)
          .then(() => {
            ventana.confirmacion='OK';
          })
          .catch(error => {
              if(error.response){ 
                if(error.response.status == 400) {
                  if(error.response.data.result.errors[0].errorCode == "096H") {
                    this.datosFirma = error.response.data.result.errors[0].info;
                    this.beforeSubmit = false;
                  }
                }
              }else{ //si no, por defecto
                    ventana.beforeSubmit=true;
                ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
                ventana.confirmacion='KO';
              }
            })
          .then(function () {
            loader.hide();
          });
        }else{*/
          
          this.$http.post(baseURI, this.params)
          .then(() => {
            ventana.confirmacion='OK';
          })
          .catch(error => {
              if(error.response){ 
                if(error.response.status == 400) {
                  if(error.response.data.result.errors[0].errorCode == "096H") {
                    this.datosFirma = error.response.data.result.errors[0].info;
                    this.beforeSubmit = false;
                  }
                }
              }else{ //si no, por defecto
                    ventana.beforeSubmit=true;
                ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
                ventana.confirmacion='KO';
              }
            })
          .then(function () {
            loader.hide();
          });
        //}
      }
    },
    }
}
</script>